/**
 * @file Generated by js-routes 2.3.6. Based on Rails 8.1.2 routes of Ell::Application.
 * @version a144853794318b66a3a41c673b267c068817d1a6316fbe3dff423ae3b3c392bf
 * @see https://github.com/railsware/js-routes
 */
// eslint-disable-next-line
const __jsr = (
// eslint-disable-next-line
() => {
    const hasProp = (value, key) => Object.prototype.hasOwnProperty.call(value, key);
    let NodeTypes;
    (function (NodeTypes) {
        NodeTypes[NodeTypes["GROUP"] = 1] = "GROUP";
        NodeTypes[NodeTypes["CAT"] = 2] = "CAT";
        NodeTypes[NodeTypes["SYMBOL"] = 3] = "SYMBOL";
        NodeTypes[NodeTypes["OR"] = 4] = "OR";
        NodeTypes[NodeTypes["STAR"] = 5] = "STAR";
        NodeTypes[NodeTypes["LITERAL"] = 6] = "LITERAL";
        NodeTypes[NodeTypes["SLASH"] = 7] = "SLASH";
        NodeTypes[NodeTypes["DOT"] = 8] = "DOT";
    })(NodeTypes || (NodeTypes = {}));
    const isBrowser = typeof window !== "undefined";
    const UnescapedSpecials = "-._~!$&'()*+,;=:@"
        .split("")
        .map((s) => s.charCodeAt(0));
    const UnescapedRanges = [
        ["a", "z"],
        ["A", "Z"],
        ["0", "9"],
    ].map((range) => range.map((s) => s.charCodeAt(0)));
    const ModuleReferences = {
        CJS: {
            define(routes) {
                if (module) {
                    module.exports = routes;
                }
            },
            isSupported() {
                return typeof module === "object";
            },
        },
        AMD: {
            define(routes) {
                if (define) {
                    define([], function () {
                        return routes;
                    });
                }
            },
            isSupported() {
                return typeof define === "function" && !!define.amd;
            },
        },
        UMD: {
            define(routes) {
                if (ModuleReferences.AMD.isSupported()) {
                    ModuleReferences.AMD.define(routes);
                }
                else {
                    if (ModuleReferences.CJS.isSupported()) {
                        try {
                            ModuleReferences.CJS.define(routes);
                        }
                        catch (error) {
                            if (error.name !== "TypeError")
                                throw error;
                        }
                    }
                }
            },
            isSupported() {
                return (ModuleReferences.AMD.isSupported() ||
                    ModuleReferences.CJS.isSupported());
            },
        },
        ESM: {
            define() {
                // Module can only be defined using ruby code generation
            },
            isSupported() {
                // Its impossible to check if "export" keyword is supported
                return true;
            },
        },
        NIL: {
            define() {
                // Defined using const __jsr = 
            },
            isSupported() {
                return true;
            },
        },
        DTS: {
            // Acts the same as ESM
            define(routes) {
                ModuleReferences.ESM.define(routes);
            },
            isSupported() {
                return ModuleReferences.ESM.isSupported();
            },
        },
    };
    class ParametersMissing extends Error {
        constructor(...keys) {
            super(`Route missing required keys: ${keys.join(", ")}`);
            this.keys = keys;
            Object.setPrototypeOf(this, Object.getPrototypeOf(this));
            this.name = ParametersMissing.name;
        }
    }
    const ReservedOptions = [
        "anchor",
        "trailing_slash",
        "subdomain",
        "host",
        "port",
        "protocol",
        "script_name",
    ];
    class UtilsClass {
        constructor() {
            this.configuration = {
                prefix: "",
                default_url_options: {},
                special_options_key: "_options",
                serializer: null || this.default_serializer.bind(this),
            };
        }
        default_serializer(value, prefix) {
            if (!prefix && !this.is_object(value)) {
                throw new Error("Url parameters should be a javascript hash");
            }
            prefix = prefix || "";
            const result = [];
            if (this.is_array(value)) {
                for (const element of value) {
                    result.push(this.default_serializer(element, prefix + "[]"));
                }
            }
            else if (this.is_object(value)) {
                for (let key in value) {
                    if (!hasProp(value, key))
                        continue;
                    let prop = value[key];
                    if (prefix) {
                        key = prefix + "[" + key + "]";
                    }
                    const subvalue = this.default_serializer(prop, key);
                    if (subvalue.length) {
                        result.push(subvalue);
                    }
                }
            }
            else {
                result.push(this.is_not_nullable(value) ||
                    false
                    ? encodeURIComponent(prefix) +
                        "=" +
                        encodeURIComponent("" + (value !== null && value !== void 0 ? value : ""))
                    : encodeURIComponent(prefix));
            }
            return result.join("&");
        }
        serialize(object) {
            return this.configuration.serializer(object);
        }
        extract_options(number_of_params, args) {
            const last_el = args[args.length - 1];
            if ((args.length > number_of_params && last_el === 0) ||
                (this.is_object(last_el) &&
                    !this.looks_like_serialized_model(last_el))) {
                if (this.is_object(last_el)) {
                    delete last_el[this.configuration.special_options_key];
                }
                return {
                    args: args.slice(0, args.length - 1),
                    options: last_el,
                };
            }
            else {
                return { args, options: {} };
            }
        }
        looks_like_serialized_model(object) {
            return (this.is_object(object) &&
                !(this.configuration.special_options_key in object) &&
                ("id" in object || "to_param" in object || "toParam" in object));
        }
        path_identifier(object) {
            const result = this.unwrap_path_identifier(object);
            return this.is_nullable(result) ||
                (false &&
                    result === false)
                ? ""
                : "" + result;
        }
        unwrap_path_identifier(object) {
            let result = object;
            if (!this.is_object(object)) {
                return object;
            }
            if ("to_param" in object) {
                result = object.to_param;
            }
            else if ("toParam" in object) {
                result = object.toParam;
            }
            else if ("id" in object) {
                result = object.id;
            }
            else {
                result = object;
            }
            return this.is_callable(result) ? result.call(object) : result;
        }
        partition_parameters(parts, required_params, default_options, call_arguments) {
            // eslint-disable-next-line prefer-const
            let { args, options } = this.extract_options(parts.length, call_arguments);
            if (args.length > parts.length) {
                throw new Error("Too many parameters provided for path");
            }
            let use_all_parts = args.length > required_params.length;
            const parts_options = {
                ...this.configuration.default_url_options,
            };
            for (const key in options) {
                const value = options[key];
                if (!hasProp(options, key))
                    continue;
                use_all_parts = true;
                if (parts.includes(key)) {
                    parts_options[key] = value;
                }
            }
            options = {
                ...this.configuration.default_url_options,
                ...default_options,
                ...options,
            };
            const keyword_parameters = {};
            let query_parameters = {};
            for (const key in options) {
                if (!hasProp(options, key))
                    continue;
                const value = options[key];
                if (key === "params") {
                    if (this.is_object(value)) {
                        query_parameters = {
                            ...query_parameters,
                            ...value,
                        };
                    }
                    else {
                        throw new Error("params value should always be an object");
                    }
                }
                else if (this.is_reserved_option(key)) {
                    keyword_parameters[key] = value;
                }
                else {
                    if (!this.is_nullable(value) &&
                        (value !== default_options[key] || required_params.includes(key))) {
                        query_parameters[key] = value;
                    }
                }
            }
            const route_parts = use_all_parts ? parts : required_params;
            let i = 0;
            for (const part of route_parts) {
                if (i < args.length) {
                    const value = args[i];
                    if (!hasProp(parts_options, part)) {
                        query_parameters[part] = value;
                        ++i;
                    }
                }
            }
            return { keyword_parameters, query_parameters };
        }
        build_route(parts, required_params, default_options, route, absolute, args) {
            const { keyword_parameters, query_parameters } = this.partition_parameters(parts, required_params, default_options, args);
            let { trailing_slash, anchor, script_name } = keyword_parameters;
            const missing_params = required_params.filter((param) => !hasProp(query_parameters, param) ||
                this.is_nullable(query_parameters[param]));
            if (missing_params.length) {
                throw new ParametersMissing(...missing_params);
            }
            let result = this.get_prefix() + this.visit(route, query_parameters);
            if (trailing_slash) {
                result = result.replace(/(.*?)[/]?$/, "$1/");
            }
            const url_params = this.serialize(query_parameters);
            if (url_params.length) {
                result += "?" + url_params;
            }
            if (anchor) {
                result += "#" + anchor;
            }
            if (script_name) {
                const last_index = script_name.length - 1;
                if (script_name[last_index] == "/" && result[0] == "/") {
                    script_name = script_name.slice(0, last_index);
                }
                result = script_name + result;
            }
            if (absolute) {
                result = this.route_url(keyword_parameters) + result;
            }
            return result;
        }
        visit(route, parameters, optional = false) {
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return this.visit(route[1], parameters, true);
                case NodeTypes.CAT:
                    return this.visit_cat(route, parameters, optional);
                case NodeTypes.SYMBOL:
                    return this.visit_symbol(route, parameters, optional);
                case NodeTypes.STAR:
                    return this.visit_globbing(route[1], parameters, true);
                case NodeTypes.LITERAL:
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        is_not_nullable(object) {
            return !this.is_nullable(object);
        }
        is_nullable(object) {
            return object === undefined || object === null;
        }
        visit_cat(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, left, right], parameters, optional) {
            const left_part = this.visit(left, parameters, optional);
            let right_part = this.visit(right, parameters, optional);
            if (optional &&
                ((this.is_optional_node(left[0]) && !left_part) ||
                    (this.is_optional_node(right[0]) && !right_part))) {
                return "";
            }
            // if left_part ends on '/' and right_part starts on '/'
            if (left_part[left_part.length - 1] === "/" && right_part[0] === "/") {
                // strip slash from right_part
                // to prevent double slash
                right_part = right_part.substring(1);
            }
            return left_part + right_part;
        }
        visit_symbol(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, key], parameters, optional) {
            const value = this.path_identifier(parameters[key]);
            delete parameters[key];
            if (value.length) {
                return this.encode_segment(value);
            }
            if (optional) {
                return "";
            }
            else {
                throw new ParametersMissing(key);
            }
        }
        encode_segment(segment) {
            if (segment.match(/^[a-zA-Z0-9-]$/)) {
                // Performance optimization for 99% of cases
                return segment;
            }
            return (segment.match(/./gu) || [])
                .map((ch) => {
                const code = ch.charCodeAt(0);
                if (UnescapedRanges.find((range) => code >= range[0] && code <= range[1]) ||
                    UnescapedSpecials.includes(code)) {
                    return ch;
                }
                else {
                    return encodeURIComponent(ch);
                }
            })
                .join("");
        }
        is_optional_node(node) {
            return [NodeTypes.STAR, NodeTypes.SYMBOL, NodeTypes.CAT].includes(node);
        }
        build_path_spec(route, wildcard = false) {
            let key;
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return `(${this.build_path_spec(route[1])})`;
                case NodeTypes.CAT:
                    return (this.build_path_spec(route[1]) + this.build_path_spec(route[2]));
                case NodeTypes.STAR:
                    return this.build_path_spec(route[1], true);
                case NodeTypes.SYMBOL:
                    key = route[1];
                    if (wildcard) {
                        return (key.startsWith("*") ? "" : "*") + key;
                    }
                    else {
                        return ":" + key;
                    }
                    break;
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                case NodeTypes.LITERAL:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        visit_globbing(route, parameters, optional) {
            const key = route[1];
            let value = parameters[key];
            delete parameters[key];
            if (this.is_nullable(value)) {
                return this.visit(route, parameters, optional);
            }
            if (this.is_array(value)) {
                value = value.join("/");
            }
            const result = this.path_identifier(value);
            return encodeURI(result);
        }
        get_prefix() {
            const prefix = this.configuration.prefix;
            return prefix.match("/$")
                ? prefix.substring(0, prefix.length - 1)
                : prefix;
        }
        route(parts_table, route_spec, absolute = false) {
            const required_params = [];
            const parts = [];
            const default_options = {};
            for (const [part, { r: required, d: value }] of Object.entries(parts_table)) {
                parts.push(part);
                if (required) {
                    required_params.push(part);
                }
                if (this.is_not_nullable(value)) {
                    default_options[part] = value;
                }
            }
            const result = (...args) => {
                return this.build_route(parts, required_params, default_options, route_spec, absolute, args);
            };
            result.requiredParams = () => required_params;
            result.toString = () => {
                return this.build_path_spec(route_spec);
            };
            return result;
        }
        route_url(route_defaults) {
            const hostname = route_defaults.host || this.current_host();
            if (!hostname) {
                return "";
            }
            const subdomain = route_defaults.subdomain
                ? route_defaults.subdomain + "."
                : "";
            const protocol = route_defaults.protocol || this.current_protocol();
            let port = route_defaults.port ||
                (!route_defaults.host ? this.current_port() : undefined);
            port = port ? ":" + port : "";
            return protocol + "://" + subdomain + hostname + port;
        }
        current_host() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname)) || "";
        }
        current_protocol() {
            var _a, _b;
            return ((isBrowser && ((_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.protocol) === null || _b === void 0 ? void 0 : _b.replace(/:$/, ""))) || "http");
        }
        current_port() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.port)) || "";
        }
        is_object(value) {
            return (typeof value === "object" &&
                Object.prototype.toString.call(value) === "[object Object]");
        }
        is_array(object) {
            return object instanceof Array;
        }
        is_callable(object) {
            return typeof object === "function" && !!object.call;
        }
        is_reserved_option(key) {
            return ReservedOptions.includes(key);
        }
        configure(new_config) {
            if (new_config.prefix) {
                console.warn("JsRoutes configuration prefix option is deprecated in favor of default_url_options.script_name.");
            }
            this.configuration = { ...this.configuration, ...new_config };
            return this.configuration;
        }
        config() {
            return { ...this.configuration };
        }
        is_module_supported(name) {
            return ModuleReferences[name].isSupported();
        }
        ensure_module_supported(name) {
            if (!this.is_module_supported(name)) {
                throw new Error(`${name} is not supported by runtime`);
            }
        }
        define_module(name, module) {
            this.ensure_module_supported(name);
            ModuleReferences[name].define(module);
            return module;
        }
    }
    const utils = new UtilsClass();
    // We want this helper name to be short
    const __jsr = {
        r(parts_table, route_spec, absolute) {
            return utils.route(parts_table, route_spec, absolute);
        },
    };
    return utils.define_module("ESM", {
        ...__jsr,
        configure: (config) => {
            return utils.configure(config);
        },
        config: () => {
            return utils.config();
        },
        serialize: (object) => {
            return utils.serialize(object);
        },
        ...{},
    });
})();
export const configure = __jsr.configure;

export const config = __jsr.config;

export const serialize = __jsr.serialize;

/**
 * Generates rails route to
 * /tenant/users/:id/access(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accessAdminUserPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tenant"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"access"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /profile/access_categories(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accessCategoriesProfilePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"access_categories"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/:id/activate_cognito(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const activateCognitoLablogsAdminUserPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"activate_cognito"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /tenant/code_values/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminCodeValuePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tenant"],[2,[7,"/"],[2,[6,"code_values"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /tenant/code_values(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminCodeValuesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"tenant"],[2,[7,"/"],[2,[6,"code_values"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /tenant/instrument_tags/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminInstrumentTagPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tenant"],[2,[7,"/"],[2,[6,"instrument_tags"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /tenant/instrument_tags(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminInstrumentTagsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"tenant"],[2,[7,"/"],[2,[6,"instrument_tags"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /tenant/instrument_types/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminInstrumentTypePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tenant"],[2,[7,"/"],[2,[6,"instrument_types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /tenant/instrument_types/:instrument_type_id/attachments/:id(.:format)
 * @param {any} instrumentTypeId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminInstrumentTypeAttachmentPath = /*#__PURE__*/ __jsr.r({"instrument_type_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tenant"],[2,[7,"/"],[2,[6,"instrument_types"],[2,[7,"/"],[2,[3,"instrument_type_id"],[2,[7,"/"],[2,[6,"attachments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /tenant/instrument_types/:instrument_type_id/attachments(.:format)
 * @param {any} instrumentTypeId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminInstrumentTypeAttachmentsPath = /*#__PURE__*/ __jsr.r({"instrument_type_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tenant"],[2,[7,"/"],[2,[6,"instrument_types"],[2,[7,"/"],[2,[3,"instrument_type_id"],[2,[7,"/"],[2,[6,"attachments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /tenant/instrument_types/:instrument_type_id/controls_reagents/:id(.:format)
 * @param {any} instrumentTypeId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminInstrumentTypeControlsReagentPath = /*#__PURE__*/ __jsr.r({"instrument_type_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tenant"],[2,[7,"/"],[2,[6,"instrument_types"],[2,[7,"/"],[2,[3,"instrument_type_id"],[2,[7,"/"],[2,[6,"controls_reagents"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /tenant/instrument_types/:instrument_type_id/controls_reagents(.:format)
 * @param {any} instrumentTypeId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminInstrumentTypeControlsReagentsPath = /*#__PURE__*/ __jsr.r({"instrument_type_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tenant"],[2,[7,"/"],[2,[6,"instrument_types"],[2,[7,"/"],[2,[3,"instrument_type_id"],[2,[7,"/"],[2,[6,"controls_reagents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /tenant/instrument_types/:instrument_type_id/maintenance_tasks/:id(.:format)
 * @param {any} instrumentTypeId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminInstrumentTypeMaintenanceTaskPath = /*#__PURE__*/ __jsr.r({"instrument_type_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tenant"],[2,[7,"/"],[2,[6,"instrument_types"],[2,[7,"/"],[2,[3,"instrument_type_id"],[2,[7,"/"],[2,[6,"maintenance_tasks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /tenant/instrument_types/:instrument_type_id/maintenance_tasks(.:format)
 * @param {any} instrumentTypeId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminInstrumentTypeMaintenanceTasksPath = /*#__PURE__*/ __jsr.r({"instrument_type_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tenant"],[2,[7,"/"],[2,[6,"instrument_types"],[2,[7,"/"],[2,[3,"instrument_type_id"],[2,[7,"/"],[2,[6,"maintenance_tasks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /tenant/instrument_types/:instrument_type_id/planning_tasks/:id(.:format)
 * @param {any} instrumentTypeId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminInstrumentTypePlanningTaskPath = /*#__PURE__*/ __jsr.r({"instrument_type_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tenant"],[2,[7,"/"],[2,[6,"instrument_types"],[2,[7,"/"],[2,[3,"instrument_type_id"],[2,[7,"/"],[2,[6,"planning_tasks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /tenant/instrument_types/:instrument_type_id/planning_tasks(.:format)
 * @param {any} instrumentTypeId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminInstrumentTypePlanningTasksPath = /*#__PURE__*/ __jsr.r({"instrument_type_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tenant"],[2,[7,"/"],[2,[6,"instrument_types"],[2,[7,"/"],[2,[3,"instrument_type_id"],[2,[7,"/"],[2,[6,"planning_tasks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /tenant/instrument_types(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminInstrumentTypesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"tenant"],[2,[7,"/"],[2,[6,"instrument_types"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /tenant/loggers/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminLoggerPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tenant"],[2,[7,"/"],[2,[6,"loggers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /tenant/loggers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminLoggersPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"tenant"],[2,[7,"/"],[2,[6,"loggers"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /tenant/roles/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminRolePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tenant"],[2,[7,"/"],[2,[6,"roles"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /tenant/roles(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminRolesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"tenant"],[2,[7,"/"],[2,[6,"roles"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /tenant/schedules(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminSchedulesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"tenant"],[2,[7,"/"],[2,[6,"schedules"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /tenant/schedules/holidays/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminSchedulesHolidayPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tenant"],[2,[7,"/"],[2,[6,"schedules"],[2,[7,"/"],[2,[6,"holidays"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /tenant/schedules/holidays(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminSchedulesHolidaysPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"tenant"],[2,[7,"/"],[2,[6,"schedules"],[2,[7,"/"],[2,[6,"holidays"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /tenant/settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminSettingsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"tenant"],[2,[7,"/"],[2,[6,"settings"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /tenant/signoff_monitoring(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminSignoffMonitoringPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"tenant"],[2,[7,"/"],[2,[6,"signoff_monitoring"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /tenant/subscription(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminSubscriptionPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"tenant"],[2,[7,"/"],[2,[6,"subscription"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /tenant/schedules/system_work_week(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminUpdateSystemWorkWeekPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"tenant"],[2,[7,"/"],[2,[6,"schedules"],[2,[7,"/"],[2,[6,"system_work_week"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /tenant/users/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminUserPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tenant"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /tenant/users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminUsersPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"tenant"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /dashboard/approvals(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const approvalsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"approvals"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /units/batch(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const batchUnitsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[6,"batch"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /instruments/by_barcode(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const byBarcodeInstrumentsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"instruments"],[2,[7,"/"],[2,[6,"by_barcode"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /session/cancel_new_password(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancelNewPasswordSessionPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"session"],[2,[7,"/"],[2,[6,"cancel_new_password"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /profile/change_pin(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const changePinProfilePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"change_pin"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /tenant/instrument_types/:id/clone(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cloneAdminInstrumentTypePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tenant"],[2,[7,"/"],[2,[6,"instrument_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"clone"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /instruments/:id/clone(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cloneInstrumentPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"instruments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"clone"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /comments/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const commentPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /comments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const commentsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"comments"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /instruments/:instrument_id/lots/:id/compare(.:format)
 * @param {any} instrumentId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const compareInstrumentLotPath = /*#__PURE__*/ __jsr.r({"instrument_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"instruments"],[2,[7,"/"],[2,[3,"instrument_id"],[2,[7,"/"],[2,[6,"lots"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"compare"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /session/complete_new_password(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const completeNewPasswordSessionPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"session"],[2,[7,"/"],[2,[6,"complete_new_password"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /compliance/bulk_review(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const complianceBulkReviewPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"compliance"],[2,[7,"/"],[2,[6,"bulk_review"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /compliance/:compliance_id/corrective_actions(.:format)
 * @param {any} complianceId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const complianceCorrectiveActionCreatePath = /*#__PURE__*/ __jsr.r({"compliance_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"compliance"],[2,[7,"/"],[2,[3,"compliance_id"],[2,[7,"/"],[2,[6,"corrective_actions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /compliance/:compliance_id/corrective_actions/:id(.:format)
 * @param {any} complianceId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const complianceCorrectiveActionDiscardPath = /*#__PURE__*/ __jsr.r({"compliance_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"compliance"],[2,[7,"/"],[2,[3,"compliance_id"],[2,[7,"/"],[2,[6,"corrective_actions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /compliance/:compliance_id/corrective_actions/:id(.:format)
 * @param {any} complianceId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const complianceCorrectiveActionUpdatePath = /*#__PURE__*/ __jsr.r({"compliance_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"compliance"],[2,[7,"/"],[2,[3,"compliance_id"],[2,[7,"/"],[2,[6,"corrective_actions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /compliance/csv_export(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const complianceCsvExportPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"compliance"],[2,[7,"/"],[2,[6,"csv_export"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /compliance(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const complianceDashboardPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"compliance"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /compliance/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const complianceDetailPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"compliance"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /compliance/:id/pdf(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const compliancePdfPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"compliance"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"pdf"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /compliance/pdf_export_report(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const compliancePdfExportReportPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"compliance"],[2,[7,"/"],[2,[6,"pdf_export_report"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /compliance/:id/review(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const complianceUpdateReviewPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"compliance"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"review"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /profile/confidential_info(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confidentialInfoProfilePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"confidential_info"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/:id/confirm_cognito(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirmCognitoLablogsAdminUserPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"confirm_cognito"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /contactUs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const contactUsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"contactUs"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/tenants/create_with_admin(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createWithAdminLablogsAdminTenantsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tenants"],[2,[7,"/"],[2,[6,"create_with_admin"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /customer_contexts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customerContextsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"customer_contexts"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /instruments/:instrument_id/tasks/:instrument_task_id/data_field_history(.:format)
 * @param {any} instrumentId
 * @param {any} instrumentTaskId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dataFieldHistoryInstrumentTaskPath = /*#__PURE__*/ __jsr.r({"instrument_id":{"r":true},"instrument_task_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"instruments"],[2,[7,"/"],[2,[3,"instrument_id"],[2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"instrument_task_id"],[2,[7,"/"],[2,[6,"data_field_history"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /departments/:id/delete_preview(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deletePreviewDepartmentPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"departments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /sites/:id/delete_preview(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deletePreviewSitePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"sites"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /units/:id/delete_preview(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deletePreviewUnitPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /departments/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const departmentPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"departments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /departments/:department_id/signoff_chain(.:format)
 * @param {any} departmentId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const departmentSignoffChainPath = /*#__PURE__*/ __jsr.r({"department_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"departments"],[2,[7,"/"],[2,[3,"department_id"],[2,[7,"/"],[2,[6,"signoff_chain"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /departments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const departmentsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"departments"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/users/:id/disable(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const disableLablogsAdminUserPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"disable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /tenant/instrument_types/:instrument_type_id/attachments/:id/download(.:format)
 * @param {any} instrumentTypeId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const downloadAdminInstrumentTypeAttachmentPath = /*#__PURE__*/ __jsr.r({"instrument_type_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tenant"],[2,[7,"/"],[2,[6,"instrument_types"],[2,[7,"/"],[2,[3,"instrument_type_id"],[2,[7,"/"],[2,[6,"attachments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /tenant/instrument_types/:id/download_image(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const downloadImageAdminInstrumentTypePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tenant"],[2,[7,"/"],[2,[6,"instrument_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download_image"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /instruments/:instrument_id/catalog_lots/:catalog_lot_lot_id/attachments/:id/download(.:format)
 * @param {any} instrumentId
 * @param {any} catalogLotLotId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const downloadInstrumentCatalogLotAttachmentPath = /*#__PURE__*/ __jsr.r({"instrument_id":{"r":true},"catalog_lot_lot_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"instruments"],[2,[7,"/"],[2,[3,"instrument_id"],[2,[7,"/"],[2,[6,"catalog_lots"],[2,[7,"/"],[2,[3,"catalog_lot_lot_id"],[2,[7,"/"],[2,[6,"attachments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /instruments/:instrument_id/service_reports/:service_report_id/attachments/:id/download(.:format)
 * @param {any} instrumentId
 * @param {any} serviceReportId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const downloadInstrumentServiceReportAttachmentPath = /*#__PURE__*/ __jsr.r({"instrument_id":{"r":true},"service_report_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"instruments"],[2,[7,"/"],[2,[3,"instrument_id"],[2,[7,"/"],[2,[6,"service_reports"],[2,[7,"/"],[2,[3,"service_report_id"],[2,[7,"/"],[2,[6,"attachments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /instruments/:instrument_id/tasks/:task_instrument_task_id/task_log/attachments/:id/download(.:format)
 * @param {any} instrumentId
 * @param {any} taskInstrumentTaskId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const downloadInstrumentTaskTaskLogAttachmentPath = /*#__PURE__*/ __jsr.r({"instrument_id":{"r":true},"task_instrument_task_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"instruments"],[2,[7,"/"],[2,[3,"instrument_id"],[2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"task_instrument_task_id"],[2,[7,"/"],[2,[6,"task_log"],[2,[7,"/"],[2,[6,"attachments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /tenant/instrument_types/draft_planning(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const draftPlanningAdminInstrumentTypesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"tenant"],[2,[7,"/"],[2,[6,"instrument_types"],[2,[7,"/"],[2,[6,"draft_planning"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /tenant/code_values/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminCodeValuePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tenant"],[2,[7,"/"],[2,[6,"code_values"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /tenant/instrument_tags/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminInstrumentTagPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tenant"],[2,[7,"/"],[2,[6,"instrument_tags"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /tenant/instrument_types/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminInstrumentTypePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tenant"],[2,[7,"/"],[2,[6,"instrument_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /tenant/loggers/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminLoggerPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tenant"],[2,[7,"/"],[2,[6,"loggers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /tenant/users/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminUserPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tenant"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /departments/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editDepartmentPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"departments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /instruments/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editInstrumentPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"instruments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /instruments/:instrument_id/tasks/:task_instrument_task_id/data_fields/:id/edit(.:format)
 * @param {any} instrumentId
 * @param {any} taskInstrumentTaskId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editInstrumentTaskDataFieldPath = /*#__PURE__*/ __jsr.r({"instrument_id":{"r":true},"task_instrument_task_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"instruments"],[2,[7,"/"],[2,[3,"instrument_id"],[2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"task_instrument_task_id"],[2,[7,"/"],[2,[6,"data_fields"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/tenants/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editLablogsAdminTenantPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tenants"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/tenant_sso_configurations/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editLablogsAdminTenantSsoConfigurationPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tenant_sso_configurations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editLablogsAdminUserPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /password_reset/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editPasswordResetPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"password_reset"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /profile/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editProfilePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /sites/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editSitePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"sites"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /units/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editUnitPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/:id/enable(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enableLablogsAdminUserPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"enable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/tenants/:id/enter_tenant(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterTenantLablogsAdminTenantPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tenants"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"enter_tenant"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /tenant/instrument_types/:id/finish_planning(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const finishPlanningAdminInstrumentTypePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tenant"],[2,[7,"/"],[2,[6,"instrument_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"finish_planning"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /instruments/:instrument_id/lots/:id/form_data(.:format)
 * @param {any} instrumentId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const formDataInstrumentLotPath = /*#__PURE__*/ __jsr.r({"instrument_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"instruments"],[2,[7,"/"],[2,[3,"instrument_id"],[2,[7,"/"],[2,[6,"lots"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"form_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /instruments/:instrument_id/lots/form_data(.:format)
 * @param {any} instrumentId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const formDataInstrumentLotsPath = /*#__PURE__*/ __jsr.r({"instrument_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"instruments"],[2,[7,"/"],[2,[3,"instrument_id"],[2,[7,"/"],[2,[6,"lots"],[2,[7,"/"],[2,[6,"form_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /instruments/:instrument_id/tasks/:task_instrument_task_id/task_log/history(.:format)
 * @param {any} instrumentId
 * @param {any} taskInstrumentTaskId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const historyInstrumentTaskTaskLogPath = /*#__PURE__*/ __jsr.r({"instrument_id":{"r":true},"task_instrument_task_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"instruments"],[2,[7,"/"],[2,[3,"instrument_id"],[2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"task_instrument_task_id"],[2,[7,"/"],[2,[6,"task_log"],[2,[7,"/"],[2,[6,"history"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/:id/impersonate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const impersonateLablogsAdminUserPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"impersonate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /impersonation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const impersonationPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"impersonation"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/tenant_sso_configurations/:id/import_metadata(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const importMetadataLablogsAdminTenantSsoConfigurationPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tenant_sso_configurations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"import_metadata"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/tenant_sso_configurations/import_metadata(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const importMetadataLablogsAdminTenantSsoConfigurationsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tenant_sso_configurations"],[2,[7,"/"],[2,[6,"import_metadata"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /instruments/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const instrumentPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"instruments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /instruments/:instrument_id/catalog_lots/:catalog_lot_lot_id/attachments/:id(.:format)
 * @param {any} instrumentId
 * @param {any} catalogLotLotId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const instrumentCatalogLotAttachmentPath = /*#__PURE__*/ __jsr.r({"instrument_id":{"r":true},"catalog_lot_lot_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"instruments"],[2,[7,"/"],[2,[3,"instrument_id"],[2,[7,"/"],[2,[6,"catalog_lots"],[2,[7,"/"],[2,[3,"catalog_lot_lot_id"],[2,[7,"/"],[2,[6,"attachments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /instruments/:instrument_id/catalog_lots/:catalog_lot_lot_id/attachments(.:format)
 * @param {any} instrumentId
 * @param {any} catalogLotLotId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const instrumentCatalogLotAttachmentsPath = /*#__PURE__*/ __jsr.r({"instrument_id":{"r":true},"catalog_lot_lot_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"instruments"],[2,[7,"/"],[2,[3,"instrument_id"],[2,[7,"/"],[2,[6,"catalog_lots"],[2,[7,"/"],[2,[3,"catalog_lot_lot_id"],[2,[7,"/"],[2,[6,"attachments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /instruments/:instrument_id/lots/:id(.:format)
 * @param {any} instrumentId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const instrumentLotPath = /*#__PURE__*/ __jsr.r({"instrument_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"instruments"],[2,[7,"/"],[2,[3,"instrument_id"],[2,[7,"/"],[2,[6,"lots"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /instruments/:instrument_id/lots/:lot_id/instrument_lot_log(.:format)
 * @param {any} instrumentId
 * @param {any} lotId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const instrumentLotInstrumentLotLogPath = /*#__PURE__*/ __jsr.r({"instrument_id":{"r":true},"lot_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"instruments"],[2,[7,"/"],[2,[3,"instrument_id"],[2,[7,"/"],[2,[6,"lots"],[2,[7,"/"],[2,[3,"lot_id"],[2,[7,"/"],[2,[6,"instrument_lot_log"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /instruments/:instrument_id/lots/:lot_id/secondary_lot_details/:id(.:format)
 * @param {any} instrumentId
 * @param {any} lotId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const instrumentLotSecondaryLotDetailPath = /*#__PURE__*/ __jsr.r({"instrument_id":{"r":true},"lot_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"instruments"],[2,[7,"/"],[2,[3,"instrument_id"],[2,[7,"/"],[2,[6,"lots"],[2,[7,"/"],[2,[3,"lot_id"],[2,[7,"/"],[2,[6,"secondary_lot_details"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /instruments/:instrument_id/lots/:lot_id/secondary_lot_details(.:format)
 * @param {any} instrumentId
 * @param {any} lotId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const instrumentLotSecondaryLotDetailsPath = /*#__PURE__*/ __jsr.r({"instrument_id":{"r":true},"lot_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"instruments"],[2,[7,"/"],[2,[3,"instrument_id"],[2,[7,"/"],[2,[6,"lots"],[2,[7,"/"],[2,[3,"lot_id"],[2,[7,"/"],[2,[6,"secondary_lot_details"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /instruments/:instrument_id/lots(.:format)
 * @param {any} instrumentId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const instrumentLotsPath = /*#__PURE__*/ __jsr.r({"instrument_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"instruments"],[2,[7,"/"],[2,[3,"instrument_id"],[2,[7,"/"],[2,[6,"lots"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /instruments/:instrument_id/reports/department_moves(.:format)
 * @param {any} instrumentId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const instrumentReportsDepartmentMovesByDatePath = /*#__PURE__*/ __jsr.r({"instrument_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"instruments"],[2,[7,"/"],[2,[3,"instrument_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"department_moves"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /instruments/:instrument_id/reports/service_reports(.:format)
 * @param {any} instrumentId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const instrumentReportsServiceReportsByDatePath = /*#__PURE__*/ __jsr.r({"instrument_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"instruments"],[2,[7,"/"],[2,[3,"instrument_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"service_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /instruments/:instrument_id/reports/status_changes(.:format)
 * @param {any} instrumentId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const instrumentReportsStatusChangesByDatePath = /*#__PURE__*/ __jsr.r({"instrument_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"instruments"],[2,[7,"/"],[2,[3,"instrument_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"status_changes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /instruments/:instrument_id/reports/task_day_occurrences(.:format)
 * @param {any} instrumentId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const instrumentReportsTaskDayOccurrencesPath = /*#__PURE__*/ __jsr.r({"instrument_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"instruments"],[2,[7,"/"],[2,[3,"instrument_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"task_day_occurrences"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /instruments/:instrument_id/reports/task_log/:instrument_task_log_id(.:format)
 * @param {any} instrumentId
 * @param {any} instrumentTaskLogId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const instrumentReportsTaskLogDetailPath = /*#__PURE__*/ __jsr.r({"instrument_id":{"r":true},"instrument_task_log_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"instruments"],[2,[7,"/"],[2,[3,"instrument_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"task_log"],[2,[7,"/"],[2,[3,"instrument_task_log_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /instruments/:instrument_id/reports/task_logs_by_date(.:format)
 * @param {any} instrumentId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const instrumentReportsTaskLogsByDatePath = /*#__PURE__*/ __jsr.r({"instrument_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"instruments"],[2,[7,"/"],[2,[3,"instrument_id"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"task_logs_by_date"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /instruments/:instrument_id/service_reports/:service_report_id/comments/:id(.:format)
 * @param {any} instrumentId
 * @param {any} serviceReportId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const instrumentServiceReportCommentPath = /*#__PURE__*/ __jsr.r({"instrument_id":{"r":true},"service_report_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"instruments"],[2,[7,"/"],[2,[3,"instrument_id"],[2,[7,"/"],[2,[6,"service_reports"],[2,[7,"/"],[2,[3,"service_report_id"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /instruments/:instrument_id/service_reports/:service_report_id/comments(.:format)
 * @param {any} instrumentId
 * @param {any} serviceReportId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const instrumentServiceReportCommentsPath = /*#__PURE__*/ __jsr.r({"instrument_id":{"r":true},"service_report_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"instruments"],[2,[7,"/"],[2,[3,"instrument_id"],[2,[7,"/"],[2,[6,"service_reports"],[2,[7,"/"],[2,[3,"service_report_id"],[2,[7,"/"],[2,[6,"comments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /instruments/:instrument_id/service_reports(.:format)
 * @param {any} instrumentId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const instrumentServiceReportsPath = /*#__PURE__*/ __jsr.r({"instrument_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"instruments"],[2,[7,"/"],[2,[3,"instrument_id"],[2,[7,"/"],[2,[6,"service_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /instrument_tags(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const instrumentTagsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"instrument_tags"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /instruments/:instrument_id/tasks/:task_instrument_task_id/data_fields/:id(.:format)
 * @param {any} instrumentId
 * @param {any} taskInstrumentTaskId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const instrumentTaskDataFieldPath = /*#__PURE__*/ __jsr.r({"instrument_id":{"r":true},"task_instrument_task_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"instruments"],[2,[7,"/"],[2,[3,"instrument_id"],[2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"task_instrument_task_id"],[2,[7,"/"],[2,[6,"data_fields"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /instruments/:instrument_id/tasks/:task_instrument_task_id/data_fields(.:format)
 * @param {any} instrumentId
 * @param {any} taskInstrumentTaskId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const instrumentTaskDataFieldsPath = /*#__PURE__*/ __jsr.r({"instrument_id":{"r":true},"task_instrument_task_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"instruments"],[2,[7,"/"],[2,[3,"instrument_id"],[2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"task_instrument_task_id"],[2,[7,"/"],[2,[6,"data_fields"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /instruments/:instrument_id/tasks/:task_instrument_task_id/instrument_lot_log(.:format)
 * @param {any} instrumentId
 * @param {any} taskInstrumentTaskId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const instrumentTaskInstrumentLotLogPath = /*#__PURE__*/ __jsr.r({"instrument_id":{"r":true},"task_instrument_task_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"instruments"],[2,[7,"/"],[2,[3,"instrument_id"],[2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"task_instrument_task_id"],[2,[7,"/"],[2,[6,"instrument_lot_log"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /instruments/:instrument_id/tasks/:task_instrument_task_id/task_log(.:format)
 * @param {any} instrumentId
 * @param {any} taskInstrumentTaskId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const instrumentTaskTaskLogPath = /*#__PURE__*/ __jsr.r({"instrument_id":{"r":true},"task_instrument_task_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"instruments"],[2,[7,"/"],[2,[3,"instrument_id"],[2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"task_instrument_task_id"],[2,[7,"/"],[2,[6,"task_log"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /instruments/:instrument_id/tasks/:task_instrument_task_id/task_log/attachments/:id(.:format)
 * @param {any} instrumentId
 * @param {any} taskInstrumentTaskId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const instrumentTaskTaskLogAttachmentPath = /*#__PURE__*/ __jsr.r({"instrument_id":{"r":true},"task_instrument_task_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"instruments"],[2,[7,"/"],[2,[3,"instrument_id"],[2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"task_instrument_task_id"],[2,[7,"/"],[2,[6,"task_log"],[2,[7,"/"],[2,[6,"attachments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /instruments/:instrument_id/tasks/:task_instrument_task_id/task_log/attachments(.:format)
 * @param {any} instrumentId
 * @param {any} taskInstrumentTaskId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const instrumentTaskTaskLogAttachmentsPath = /*#__PURE__*/ __jsr.r({"instrument_id":{"r":true},"task_instrument_task_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"instruments"],[2,[7,"/"],[2,[3,"instrument_id"],[2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"task_instrument_task_id"],[2,[7,"/"],[2,[6,"task_log"],[2,[7,"/"],[2,[6,"attachments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /instruments/:instrument_id/tasks/current_schedule(.:format)
 * @param {any} instrumentId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const instrumentTasksCurrentSchedulePath = /*#__PURE__*/ __jsr.r({"instrument_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"instruments"],[2,[7,"/"],[2,[3,"instrument_id"],[2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[6,"current_schedule"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /instruments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const instrumentsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"instruments"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /instruments/tasks/frequencies(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const instrumentsTasksFrequenciesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"instruments"],[2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[6,"frequencies"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /session/keep_alive(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const keepAliveSessionPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"session"],[2,[7,"/"],[2,[6,"keep_alive"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/logout(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lablogsAdminLogoutSessionPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"logout"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/login(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lablogsAdminNewSessionPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"login"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lablogsAdminRootPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/login(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lablogsAdminSessionPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"login"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/tenants/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lablogsAdminTenantPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tenants"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/tenant_sso_configurations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lablogsAdminTenantSsoConfigurationPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tenant_sso_configurations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/tenant_sso_configurations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lablogsAdminTenantSsoConfigurationsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tenant_sso_configurations"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/tenants(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lablogsAdminTenantsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tenants"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lablogsAdminUserPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lablogsAdminUsersPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /loggers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const loggersPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"loggers"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /tenant/instrument_types/:instrument_type_id/controls_reagents/lot/:lot_id(.:format)
 * @param {any} instrumentTypeId
 * @param {any} lotId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lotAdminInstrumentTypeControlsReagentsPath = /*#__PURE__*/ __jsr.r({"instrument_type_id":{"r":true},"lot_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tenant"],[2,[7,"/"],[2,[6,"instrument_types"],[2,[7,"/"],[2,[3,"instrument_type_id"],[2,[7,"/"],[2,[6,"controls_reagents"],[2,[7,"/"],[2,[6,"lot"],[2,[7,"/"],[2,[3,"lot_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /tenant/users/:id/manage(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const manageAdminUserPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tenant"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"manage"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /tenant/code_values/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminCodeValuePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"tenant"],[2,[7,"/"],[2,[6,"code_values"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /tenant/instrument_tags/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminInstrumentTagPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"tenant"],[2,[7,"/"],[2,[6,"instrument_tags"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /tenant/instrument_types/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminInstrumentTypePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"tenant"],[2,[7,"/"],[2,[6,"instrument_types"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /tenant/loggers/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminLoggerPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"tenant"],[2,[7,"/"],[2,[6,"loggers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /tenant/users/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminUserPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"tenant"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /units/new_batch(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newBatchUnitsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[6,"new_batch"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /departments/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newDepartmentPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"departments"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /instruments/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newInstrumentPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"instruments"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /instruments/:instrument_id/tasks/:task_instrument_task_id/data_fields/new(.:format)
 * @param {any} instrumentId
 * @param {any} taskInstrumentTaskId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newInstrumentTaskDataFieldPath = /*#__PURE__*/ __jsr.r({"instrument_id":{"r":true},"task_instrument_task_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"instruments"],[2,[7,"/"],[2,[3,"instrument_id"],[2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"task_instrument_task_id"],[2,[7,"/"],[2,[6,"data_fields"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /instruments/:instrument_id/tasks/:task_instrument_task_id/task_log/new(.:format)
 * @param {any} instrumentId
 * @param {any} taskInstrumentTaskId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newInstrumentTaskTaskLogPath = /*#__PURE__*/ __jsr.r({"instrument_id":{"r":true},"task_instrument_task_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"instruments"],[2,[7,"/"],[2,[3,"instrument_id"],[2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"task_instrument_task_id"],[2,[7,"/"],[2,[6,"task_log"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/tenant_sso_configurations/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newLablogsAdminTenantSsoConfigurationPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tenant_sso_configurations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newLablogsAdminUserPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /password_reset/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newPasswordResetPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"password_reset"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /session/new_password(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newPasswordSessionPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"session"],[2,[7,"/"],[2,[6,"new_password"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /session/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newSessionPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"session"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /sites/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newSitePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sites"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /units/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newUnitPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/tenants/new_with_admin(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newWithAdminLablogsAdminTenantsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tenants"],[2,[7,"/"],[2,[6,"new_with_admin"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboard/non_compliance/bulk_review(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const nonComplianceBulkReviewPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"non_compliance"],[2,[7,"/"],[2,[6,"bulk_review"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboard/non_compliance(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const nonComplianceDashboardPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"non_compliance"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /dashboard/non_compliance/:required_compliance_id/resolve_log(.:format)
 * @param {any} requiredComplianceId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const nonComplianceResolveLogPath = /*#__PURE__*/ __jsr.r({"required_compliance_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"non_compliance"],[2,[7,"/"],[2,[3,"required_compliance_id"],[2,[7,"/"],[2,[6,"resolve_log"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboard/non_compliance/:required_compliance_id/review(.:format)
 * @param {any} requiredComplianceId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const nonComplianceReviewPath = /*#__PURE__*/ __jsr.r({"required_compliance_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"non_compliance"],[2,[7,"/"],[2,[3,"required_compliance_id"],[2,[7,"/"],[2,[6,"review"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboard/non_compliance/selectable_ids(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const nonComplianceSelectableIdsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"non_compliance"],[2,[7,"/"],[2,[6,"selectable_ids"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /notification_preference(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const notificationPreferencePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"notification_preference"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /tenant/users/:id/notification_preferences(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const notificationPreferencesAdminUserPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tenant"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"notification_preferences"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /oidc/callback/:tenant_code(.:format)
 * @param {any} tenantCode
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oidcCallbackPath = /*#__PURE__*/ __jsr.r({"tenant_code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"oidc"],[2,[7,"/"],[2,[6,"callback"],[2,[7,"/"],[2,[3,"tenant_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /oidc/init/:tenant_code(.:format)
 * @param {any} tenantCode
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oidcInitPath = /*#__PURE__*/ __jsr.r({"tenant_code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"oidc"],[2,[7,"/"],[2,[6,"init"],[2,[7,"/"],[2,[3,"tenant_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /organization(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"organization"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /password_reset(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const passwordResetPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"password_reset"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /instruments/:instrument_id/tasks/:task_instrument_task_id/task_log/pdf/:instrument_task_log_id(.:format)
 * @param {any} instrumentId
 * @param {any} taskInstrumentTaskId
 * @param {any} instrumentTaskLogId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pdfInstrumentTaskTaskLogPath = /*#__PURE__*/ __jsr.r({"instrument_id":{"r":true},"task_instrument_task_id":{"r":true},"instrument_task_log_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"instruments"],[2,[7,"/"],[2,[3,"instrument_id"],[2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"task_instrument_task_id"],[2,[7,"/"],[2,[6,"task_log"],[2,[7,"/"],[2,[6,"pdf"],[2,[7,"/"],[2,[3,"instrument_task_log_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /tenant/instrument_types/:id/planning(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const planningAdminInstrumentTypePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tenant"],[2,[7,"/"],[2,[6,"instrument_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"planning"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /tenant/instrument_types/:id/planning_identity(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const planningIdentityAdminInstrumentTypePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tenant"],[2,[7,"/"],[2,[6,"instrument_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"planning_identity"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /profile(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const profilePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"profile"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/users/:id/remove_tenant(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const removeTenantLablogsAdminUserPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"remove_tenant"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /tenant/instrument_types/:instrument_type_id/maintenance_tasks/reorder(.:format)
 * @param {any} instrumentTypeId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reorderAdminInstrumentTypeMaintenanceTasksPath = /*#__PURE__*/ __jsr.r({"instrument_type_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tenant"],[2,[7,"/"],[2,[6,"instrument_types"],[2,[7,"/"],[2,[3,"instrument_type_id"],[2,[7,"/"],[2,[6,"maintenance_tasks"],[2,[7,"/"],[2,[6,"reorder"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/monthly/:report_id/attachments(.:format)
 * @param {any} reportId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reportAttachmentCreatePath = /*#__PURE__*/ __jsr.r({"report_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"monthly"],[2,[7,"/"],[2,[3,"report_id"],[2,[7,"/"],[2,[6,"attachments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/monthly/:report_id/attachments/:id(.:format)
 * @param {any} reportId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reportAttachmentDiscardPath = /*#__PURE__*/ __jsr.r({"report_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"monthly"],[2,[7,"/"],[2,[3,"report_id"],[2,[7,"/"],[2,[6,"attachments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/monthly/:report_id/attachments/:id/download(.:format)
 * @param {any} reportId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reportAttachmentDownloadPath = /*#__PURE__*/ __jsr.r({"report_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"monthly"],[2,[7,"/"],[2,[3,"report_id"],[2,[7,"/"],[2,[6,"attachments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/monthly/:report_id/corrective_actions(.:format)
 * @param {any} reportId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reportCorrectiveActionCreatePath = /*#__PURE__*/ __jsr.r({"report_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"monthly"],[2,[7,"/"],[2,[3,"report_id"],[2,[7,"/"],[2,[6,"corrective_actions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/monthly/:report_id/corrective_actions/:id(.:format)
 * @param {any} reportId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reportCorrectiveActionDiscardPath = /*#__PURE__*/ __jsr.r({"report_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"monthly"],[2,[7,"/"],[2,[3,"report_id"],[2,[7,"/"],[2,[6,"corrective_actions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/monthly/:report_id/corrective_actions/:id(.:format)
 * @param {any} reportId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reportCorrectiveActionUpdatePath = /*#__PURE__*/ __jsr.r({"report_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"monthly"],[2,[7,"/"],[2,[3,"report_id"],[2,[7,"/"],[2,[6,"corrective_actions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/deleted-history(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reportsDeletedHistoryPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"deleted-history"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /reports/deleted-history/csv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reportsDeletedHistoryCsvPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"deleted-history"],[2,[7,"/"],[2,[6,"csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/deleted-history/pdf(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reportsDeletedHistoryPdfPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"deleted-history"],[2,[7,"/"],[2,[6,"pdf"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/departments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reportsDepartmentsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"departments"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /reports/departments/csv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reportsDepartmentsCsvPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"departments"],[2,[7,"/"],[2,[6,"csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/departments/pdf(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reportsDepartmentsPdfPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"departments"],[2,[7,"/"],[2,[6,"pdf"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/instruments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reportsInstrumentsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"instruments"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /reports/instruments/csv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reportsInstrumentsCsvPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"instruments"],[2,[7,"/"],[2,[6,"csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/instruments/pdf(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reportsInstrumentsPdfPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"instruments"],[2,[7,"/"],[2,[6,"pdf"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/maintenance_logs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reportsMaintenanceLogsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"maintenance_logs"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /reports/maintenance_logs/pdf(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reportsMaintenanceLogsPdfPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"maintenance_logs"],[2,[7,"/"],[2,[6,"pdf"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/monthly(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reportsMonthlyPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"monthly"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /reports/monthly/:id/download_export/:format_type(.:format)
 * @param {any} id
 * @param {any} formatType
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reportsMonthlyDownloadExportPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format_type":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"monthly"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download_export"],[2,[7,"/"],[2,[3,"format_type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/monthly/:id/download_pdf(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reportsMonthlyDownloadPdfPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"monthly"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download_pdf"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/monthly/:id/download_xlsx(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reportsMonthlyDownloadXlsxPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"monthly"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download_xlsx"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/monthly/period(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reportsMonthlyPeriodPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"monthly"],[2,[7,"/"],[2,[6,"period"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/monthly/:id/request_export/:format_type(.:format)
 * @param {any} id
 * @param {any} formatType
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reportsMonthlyRequestExportPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format_type":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"monthly"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"request_export"],[2,[7,"/"],[2,[3,"format_type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/monthly/:id/request_pdf(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reportsMonthlyRequestPdfPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"monthly"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"request_pdf"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/monthly/:id/request_xlsx(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reportsMonthlyRequestXlsxPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"monthly"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"request_xlsx"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/monthly/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reportsMonthlyShowPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"monthly"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/monthly/:id/sign(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reportsMonthlySignPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"monthly"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"sign"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/monthly/:id/undo_sign(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reportsMonthlyUndoSignPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"monthly"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"undo_sign"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/monthly/:id/users_pdf(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reportsMonthlyUsersPdfPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"monthly"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"users_pdf"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/signatures(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reportsSignaturesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"signatures"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /reports/sites(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reportsSitesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"sites"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /reports/sites/csv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reportsSitesCsvPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"sites"],[2,[7,"/"],[2,[6,"csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/sites/pdf(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reportsSitesPdfPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"sites"],[2,[7,"/"],[2,[6,"pdf"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/units(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reportsUnitsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"units"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /reports/units/csv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reportsUnitsCsvPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[6,"csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/units/pdf(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reportsUnitsPdfPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[6,"pdf"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reportsUsersPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /reports/users/csv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reportsUsersCsvPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reports/users/pdf(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reportsUsersPdfPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"pdf"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /tenant/users/:id/resend_access(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resendAccessAdminUserPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tenant"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resend_access"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/:id/resend_access(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resendAccessLablogsAdminUserPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resend_access"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /sites/resolve_timezone(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resolveTimezoneSitesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sites"],[2,[7,"/"],[2,[6,"resolve_timezone"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /tenant/instrument_tags/:id/restore(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const restoreAdminInstrumentTagPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tenant"],[2,[7,"/"],[2,[6,"instrument_tags"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"restore"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /departments/:id/restore(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const restoreDepartmentPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"departments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"restore"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /departments/:id/restore_preview(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const restorePreviewDepartmentPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"departments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"restore_preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /sites/:id/restore_preview(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const restorePreviewSitePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"sites"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"restore_preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /units/:id/restore_preview(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const restorePreviewUnitPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"restore_preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /sites/:id/restore(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const restoreSitePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"sites"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"restore"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /units/:id/restore(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const restoreUnitPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"restore"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /instruments/:instrument_id/lots/:id/retire(.:format)
 * @param {any} instrumentId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const retireInstrumentLotPath = /*#__PURE__*/ __jsr.r({"instrument_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"instruments"],[2,[7,"/"],[2,[3,"instrument_id"],[2,[7,"/"],[2,[6,"lots"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"retire"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rich_text_images/*id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const richTextImagePath = /*#__PURE__*/ __jsr.r({"id":{"r":true}}, [2,[7,"/"],[2,[6,"rich_text_images"],[2,[7,"/"],[5,[3,"id"]]]]]);

/**
 * Generates rails route to
 * /rich_text_images(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const richTextImagesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rich_text_images"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rootPath = /*#__PURE__*/ __jsr.r({}, [7,"/"]);

/**
 * Generates rails route to
 * /saml/acs/:tenant_code(.:format)
 * @param {any} tenantCode
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const samlAcsPath = /*#__PURE__*/ __jsr.r({"tenant_code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"saml"],[2,[7,"/"],[2,[6,"acs"],[2,[7,"/"],[2,[3,"tenant_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /saml/init/:tenant_code(.:format)
 * @param {any} tenantCode
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const samlInitPath = /*#__PURE__*/ __jsr.r({"tenant_code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"saml"],[2,[7,"/"],[2,[6,"init"],[2,[7,"/"],[2,[3,"tenant_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /saml/metadata(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const samlMetadataPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"saml"],[2,[7,"/"],[2,[6,"metadata"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /session(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sessionPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"session"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/users/:id/set_password(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const setPasswordLablogsAdminUserPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"set_password"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /sidekiq
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sidekiqWebPath = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"sidekiq"]]);

/**
 * Generates rails route to
 * /sites/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sitePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"sites"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /sites(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sitesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sites"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /sso/:tenant_code(.:format)
 * @param {any} tenantCode
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ssoEntryPath = /*#__PURE__*/ __jsr.r({"tenant_code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"sso"],[2,[7,"/"],[2,[3,"tenant_code"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /instruments/:id/status_update_form(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const statusUpdateFormInstrumentPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"instruments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"status_update_form"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboard/tasks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tasksDashboardPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"tasks"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /dashboard/tasks/calendar(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tasksDashboardCalendarPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[6,"calendar"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboard/tasks/data_fields/:instrument_task_id(.:format)
 * @param {any} instrumentTaskId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tasksDashboardDataFieldsPath = /*#__PURE__*/ __jsr.r({"instrument_task_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[6,"data_fields"],[2,[7,"/"],[2,[3,"instrument_task_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboard/tasks/log_context/:instrument_task_id(.:format)
 * @param {any} instrumentTaskId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tasksDashboardLogContextPath = /*#__PURE__*/ __jsr.r({"instrument_task_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[6,"log_context"],[2,[7,"/"],[2,[3,"instrument_task_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboard/tasks/nc_overflow(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tasksDashboardNcOverflowPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[6,"nc_overflow"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboard/tasks/overflow(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tasksDashboardOverflowPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[6,"overflow"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboard/tasks/task_notes/:instrument_task_id(.:format)
 * @param {any} instrumentTaskId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tasksDashboardTaskNotesPath = /*#__PURE__*/ __jsr.r({"instrument_task_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[6,"task_notes"],[2,[7,"/"],[2,[3,"instrument_task_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /tenant_context(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tenantContextPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"tenant_context"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /instruments/:id/transfer_form(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const transferFormInstrumentPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"instruments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"transfer_form"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /instruments/:id/transfer(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const transferInstrumentPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"instruments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"transfer"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /units/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unitPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /units(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unitsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"units"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/users/:id/update_password(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updatePasswordLablogsAdminUserPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_password"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /instruments/:id/update_status(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateStatusInstrumentPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"instruments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /tenant/instrument_types/:instrument_type_id/planning_tasks/:id/update_tags(.:format)
 * @param {any} instrumentTypeId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateTagsAdminInstrumentTypePlanningTaskPath = /*#__PURE__*/ __jsr.r({"instrument_type_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tenant"],[2,[7,"/"],[2,[6,"instrument_types"],[2,[7,"/"],[2,[3,"instrument_type_id"],[2,[7,"/"],[2,[6,"planning_tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_tags"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /tenant/instrument_types/:id/upload_image(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const uploadImageAdminInstrumentTypePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tenant"],[2,[7,"/"],[2,[6,"instrument_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"upload_image"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /password_reset/verify_code(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const verifyCodePasswordResetPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"password_reset"],[2,[7,"/"],[2,[6,"verify_code"],[1,[2,[8,"."],[3,"format"]]]]]]]);

